
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// Base state control
import actions from './actions';
import getters from './getters';

// Modules
import auction from './modules/auction';
import auth from './modules/auth';
import car from './modules/car';
import category from './modules/category';
import colors from './modules/colors';
import dashboard from './modules/dashboard';
import manufacture from './modules/manufacture';
import material from './modules/material';
import measure from './modules/measure';
import notification from './modules/notification';
import password from './modules/password';
import payment from './modules/payment';
import promotion from './modules/promotion';
import support from './modules/support';
import typefuel from './modules/typefuel';
import user from './modules/user';
import vip from './modules/vip';



export default new Vuex.Store({
  actions,
  getters,
  modules: {
    auth,
    user,
    password,
    dashboard,
    support,
    notification,
    payment,
    material,
    category,
    typefuel,
    colors,
    manufacture,
    measure,
    car,
    auction,
    promotion,
    vip
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js